<template>
    <div class="task-cell">
        <md-card md-with-hover v-for="cell in combinedCells" :key="cell.id">
            <md-card-header>
                <md-card-header-text>
                    <div class="md-title">
                        {{ cell.downloadFilename }}
                    </div>
                    <div class="md-subhead" v-if="cell.layerLabel">
                        <md-icon>map</md-icon>
                        <span>Label: {{ cell.layerLabel }}</span>
                    </div>
                </md-card-header-text>
            </md-card-header>
            <md-card-content>
                <md-card-media
                    md-small
                    v-if="(cell.thumbnail && timebeforedelete(cell).timeremaining > 47)"
                    key="thumbnail"
                >
                    <img
                        style="max-width: 50%; max-height: 50%"
                        :src="cell.thumbnail"
                        alt="Thumbnail of download image"
                    />
                </md-card-media>
                <div class="status-messages">
                    <div>
                        <b>Status:</b>
                        {{ statusMessage(cell.state) }}
                        <span class="dot" :style="statuscolour(cell)">
                        </span>
                    </div>
                </div>
                <div
                    class="status-messages"
                    v-if="cell.state == 'FAILED'"
                    key="error_message"
                >
                    <div>
                        <b>Error:</b>
                        <span> {{ cell.error }}</span>
                    </div>
                </div>
                <div
                    class="status-messages"
                    v-if="cell.state == 'REJECTED'"
                    key="rejected_message"
                >
                    <div>
                        <b>Rejected:</b>
                        <span> {{ cell.error }}</span>
                    </div>
                </div>
                <div 
                    class="status-messages" 
                    v-if="!cell.request"
                    key="status_message"
                    >
                    <div>
                        <b>Last status check:</b>
                        <span
                            :style="laststatuscheck(cell).bkgroundcolor"
                        >
                            {{ laststatuscheck(cell).msg }}
                        </span>
                    </div>
                </div>
                <div 
                    class="status-messages" 
                    v-if="cell.startedAt"
                    key="started_message"
                    >
                    <div>
                        <b>Started at:</b>
                        <span>
                            {{ cell.startedAt.toUTCString() }}
                        </span>
                    </div>
                </div>
                <div 
                    class="status-messages" 
                    v-if="cell.jobID"
                    key="job_message"
                    >
                    <div>
                        <b>Task ID:</b>
                        <span> {{ cell.jobID }}</span>
                    </div>
                </div>
                <div 
                    v-if="cell.warnings && cell.warnings.length > 0" 
                    class="status-messages"
                    key="covnversion_message"
                    >
                    <div>
                        <b>Conversion warnings:</b>
                    </div>
                </div>
                <div 
                    v-if="cell.warnings && cell.warnings.length > 0"
                    key="warnings_message"
                    >
                    <ul class="warning-messages">
                        <li v-for="(warning, index) in cell.warnings" :key="index">{{warning}}</li>
                    </ul>
                </div>
                <div 
                    v-if="cell.rundoc" 
                    class="status-messages"
                    key="rundoc_message"
                    >
                    <div>
                        <b>Workflow ID:</b>
                        <span>{{ cell.rundoc }}</span>
                    </div>
                </div>
                <div 
                    class="status-messages" 
                    v-if="cell.cellType === 'download' && (cell.state == 'SUCCEEDED' || cell.state == 'COMPLETED')"
                    key="download_message"
                    >
                    <div>
                        <md-icon :style="timebeforedelete(cell).style">
                            warning
                        </md-icon>
                        <b>Time remaining before download deleted:</b>
                        <span>
                            {{ timebeforedelete(cell).timeremaining }}h
                        </span>
                    </div>
                </div>
                <md-card-actions>
                    <md-button
                        class="md-primary"
                        @click="checkTaskStatus(cell)"
                        v-if="
                            !cell.checkInProgress &&
                            cell.state != 'SUCCEEDED' &&
                            cell.state != 'COMPLETED' &&
                            cell.state != 'FAILED' &&
                            cell.request === false
                        "
                        key="check_status"
                    >
                        <md-icon>refresh</md-icon>REFRESH
                        <md-tooltip md-direction="right">
                            {{ cell.cellType === 'download' ? 'Get the current status of your download' : 'Get the current status of your upload' }}
                        </md-tooltip>
                    </md-button>
                    <md-button
                        class="md-primary"
                        @click="getLinks(cell)"
                        v-if="
                            cell.cellType === 'download' &&
                            (cell.state == 'SUCCEEDED' ||
                            cell.state == 'COMPLETED')
                        "
                        key="get_links"
                    >
                        <md-icon>download</md-icon> GET DOWNLOAD LINKS
                        <md-tooltip md-direction="right">
                            Get links to GeoTIFF downloads
                        </md-tooltip>
                    </md-button>
                    <LoadAssetButton
                        v-if="
                            cell.cellType === 'upload' &&
                            successStates.includes(cell.state)
                        " 
                        :asset="cell.asset"
                        :user="user"
                        key="load_asset"
                        />
                    <md-button
                        class="md-primary"
                        @click="() => $emit('start-export', cell.docID)"
                        v-if="cell.request === true"
                        key="export_request"
                        >
                        <md-icon>play_arrow</md-icon> START EXPORT
                        <md-tooltip md-direction="right">
                            Start the export of your data
                        </md-tooltip>
                    </md-button>
                    <md-button
                        v-show="
                            cell.cellType === 'upload' &&
                            (successStates.includes(cell.state) || cell.state == 'FAILED')
                        " 
                        class="md-icon-button md-list-action" 
                        @click.stop="deleteUploadedAsset(cell)"
                        key="delete_upload"
                    >
                        <md-tooltip md-direction="top">Click to delete asset</md-tooltip>  
                        <md-icon>delete</md-icon> 
                    </md-button>

                </md-card-actions>

                <md-list
                    v-for="link in cell.downloadlinks"
                    :key="link.filename"
                >
                    <md-list-item
                        v-if="!link.downloaded"
                        @click.stop="getDownloadURL(link)"
                    >
                        <md-icon class="md-primary">save</md-icon>
                        <div class="md-list-item-text">
                            <span>{{ link.filename }}</span>
                        </div>
                    </md-list-item>
                    <md-list-item v-if="link.downloaded">
                        <md-icon>check</md-icon>
                        <div class="md-list-item-text">
                            <span>{{ link.filename }}</span>
                        </div>
                    </md-list-item>
                </md-list>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import { functions } from "../firebaseFunctions.js";
import {
    storage,
    firebaseConfig,
} from "@/firebase.js";
import { AuthService } from "@/services/auth.service";
import LoadAssetButton from '@/components/LoadAssetButton.vue';

export default {
    name: "TaskCell",
    components: {
        LoadAssetButton
    },
    props: {
        combinedCells: {
            type: Array,
            required: true,
        },
        orgId: {
            type: String,
            required: true,
        },
    },
    watch: {
        combinedCells: {
            deep: true,
            immediate: true,
            handler: function(newVal) {
                return newVal
            }
        }
    },
    data:() => ({
        user: null,
        successStates: ['SUCCEEDED', 'COMPLETED'],
        config: firebaseConfig,
    }),
    created() {
        this.subscription = AuthService.loggedUser$.subscribe((user) => {
            this.user = user;
        });
    },
    methods: {
        deleteUploadedAsset(asset) {
            console.info("marked for delete" , asset.filename)
            console.log("deleting asset", asset)
            this.$emit("delete-asset-doc", asset.jobID)
        },
        getDownloadURL(link) {
            let element = document.createElement("a");
            element.setAttribute("download", "");
            element.setAttribute("target", "_blank");
            element.setAttribute("href", link.url);
            element.setAttribute("type", "image/tiff");
            element.style.display = "none";

            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);

            link.downloaded = true;
        },
        async getLinks(cell) {
            let outputFolderPath =
                "gs://" + this.config.storageBucket + "/" + cell.downloadPrefix;
            let pIndex = outputFolderPath.lastIndexOf("/");
            outputFolderPath = outputFolderPath.substr(0, pIndex);

            let outputFolderRef = storage.refFromURL(outputFolderPath);
            cell.downloadlinks = [];
            outputFolderRef.listAll().then(function (itemsres) {
                itemsres.items.forEach(function (item) {
                    item.getDownloadURL().then(function (url) {
                        cell.downloadlinks.push({
                            filename: item.name,
                            url: url,
                            downloaded: false,
                        });
                    });
                });
            });
        },
        checkTaskStatus: async function (cell) {
            cell.checkInProgress = true;
            
            if (cell.cellType === 'download') {
                let data = {
                    "org_id": this.orgId,
                    "task_id": cell.jobID
                };
                await functions.checkTaskStatus(data).then(
                    () => {
                        // console.log("Tasks.vue:checkTaskStatus submitted") ;
                    },
                    (error) => {
                        console.error(
                            "Tasks.vue:checkTaskStatus status error:" + error
                        );
                        cell.checkInProgress = false;
                    }
                );
            } else if (cell.cellType === 'upload') {
                let data = {
                    "org_id": this.user.orgId,
                    "user_id": this.user.uid,
                    "task_id": cell.taskID,
                    "asset_id": cell.jobID
                };

                await functions.geeUploadStatus(data).then(
                    () => {
                        // console.log("Tasks.vue:checkTaskStatus submitted") ;
                    },
                    (error) => {
                        console.error(
                            "Tasks.vue:checkTaskStatus status error:" + error
                        );
                        cell.checkInProgress = false;
                    }
                );
            }
            
        },
        timebeforedelete(cell) {
            let startDate = cell.startedAt;
    
            let startDatePlus48h = startDate.getTime() + 2 * 1000 * 3600 * 24;
            let now = new Date();
            let timewarning = false;
            // To calculate the time difference of two dates
            let Difference_In_Time = startDatePlus48h - now.getTime();

            // To calculate the no. of days between two dates
            let Difference_In_Hours = Difference_In_Time / (1000 * 3600);
            let style = {};
            if (Difference_In_Hours < 30) {
                timewarning = true;
                style = { "background-color": "#ff7132" };
            }

            let result = {
                timeremaining: Difference_In_Hours.toFixed(1),
                timewarning: timewarning,
                style: style,
            };
            return result;
        },
        statusMessage(cellState) {
            cellState = cellState.toUpperCase()
            switch(cellState) {
                case 'READY':
                    return 'STAGED'
                default:
                    return cellState
            }

        },
        statuscolour(cell) {
            let bkcolour = "#231f20";

            switch (cell.state) {
                case "COMPLETED":
                    bkcolour = "#84da59";
                    break;
                case "SUCCEEDED":
                    bkcolour = "#84da59";
                    break;
                case "PROCESSING":
                    bkcolour = "#ff7132";
                    break;
                case "RUNNING":
                    bkcolour = "#ff7132";
                    break;
                case "READY":
                    bkcolour = "#f06c6d";
                    break;
                case "PENDING":
                    bkcolour = "#f06c6d";
                    break;
                case "QUEUED":
                    bkcolour = "#ef4748";
                    break;
                case "CANCELLED":
                    bkcolour = "#231f20";
                    break;
                case "CANCELLING":
                    bkcolour = "#231f20";
                    break;
                case "FAILED":
                    bkcolour = "#231f20";
                    break;
                default:
                    bkcolour = "#231f20";
            }

            return { "background-color": bkcolour };
        },
        laststatuscheck(cell) {
            if (cell.checkInProgress) {
                return {
                    msg: "STATUS CHECK IN PROGRESS",
                    state: "in progress",
                    bkgroundcolor: { "background-color": "#ff7132" },
                };
            } else if (cell.laststatuscheck) {
                let datetimeStr = cell.laststatuscheck.toDate().toUTCString();
                return {
                    msg: datetimeStr,
                    state: "in progress",
                    bkgroundcolor: { "background-color": "inherit" },
                };
            }
        },
    }
}
</script>